import React, { useState } from "react";
import { Field } from "formik";
import * as moment from 'moment';
import { BIDFORMAT } from 'web/components/utils/dateOfBirthValidation';
import RadioButton from "web/components/form-elements/RadioButton";
import DebitCard from "../../Debit-Credit-Card";
import AccountDetail from "./account-detail";
import styles from "../../corporate.module.scss";
import states from 'states-us';
import RightArrow from "web/assets/images/right-arrow-dark-blue.webp";
import { Tooltip } from 'reactstrap';
import information from "web/assets/images/informationIcon.png";
import DatePicker from 'web/components/form-elements/DatePicker';
import TextInput from 'web/components/form-elements/TextInput';
import TextArea from 'web/components/form-elements/TextArea';
import DecimalNumberInput from 'web/components/form-elements/DecimalNumberInput';
import NumberInput from 'web/components/form-elements/NumberInput';
import UploadSpecification from 'web/components/UploadSpecification';
import Select from 'web/components/form-elements/Select';
import { StepFourContainer, PaymentMethod, SubHeading, } from "web/pages/account/registration/corporate-Registration-Styled";

export default ({
  setFieldValue,
  props,
  setTaxIdState,
  uploadDriverLisence,
  pageLanguageContents
}) => {
  let fileArr = [];
  const [paymentType, setPaymentType] = useState("");
  const radioTypes = [
    {
      value: "bankAccount",
      label: pageLanguageContents?.Arrow2_Account[37]?.Seller_OptionOne,
    },
    {
      value: "debitCard",
      label: pageLanguageContents?.Arrow2_Account[44]?.Seller_OptionTwo,
    },
  ];

  let taxLicenseRadioTypes
  if (props.values.reseller === "active") {
    taxLicenseRadioTypes = [
      {
        value: '0',
        label: 'Tax ID',
      },
    ];
  } else {
    taxLicenseRadioTypes = [
      {
        value: '0',
        label: 'Tax ID',
      },
      {
        value: '1',
        label: "Driver's License",
      },
    ];
  }

  const territoryStates = states.filter((x) => x.contiguous);
  let stateArr = []
  for (let i = 0; i < territoryStates.length; i++) {
    let obj = {
      value: territoryStates[i].name,
      label: `${territoryStates[i].abbreviation}-${territoryStates[i].name}`,
      isoCode: territoryStates[i].abbreviation
    }
    stateArr.push(obj)
  }

  const [tooltipOpenSeller, setTooltipSeller] = useState(false);
  const iIconSeller = (infoTxt) => {
    return <>
      <img
        id="TooltipSeller"
        src={information}
        style={{
          paddingLeft: "5px",
          position: "relative",
          top: "-1px",
        }}
      />
      <Tooltip
        placement="right"
        isOpen={tooltipOpenSeller}
        target="TooltipSeller"
        toggle={() =>
          setTooltipSeller(!tooltipOpenSeller)
        }
      >
        {infoTxt}
      </Tooltip>
    </>
  }
  const onChangeHandler = (e) => {
    setFieldValue("accountHolderName", '')
    setFieldValue("bankAccount", '')
    setFieldValue("bankRouting", '')
    setPaymentType(e.target.value);
  };

  const [tooltipOpenDnb, setTooltipOpenDnb] = useState(false);
  const iIcon = () => {
    return <>
      <img
        id="TooltipOne"
        src={information}
        style={{
          paddingLeft: "5px",
          position: "relative",
          top: "-1px",
        }}
      />
      <Tooltip
        placement="right"
        isOpen={tooltipOpenDnb}
        target="TooltipOne"
        toggle={() =>
          setTooltipOpenDnb(!tooltipOpenDnb)
        }
      >
        {pageLanguageContents?.Arrow2_Account[98]?.DNB_Info}
      </Tooltip>
    </>
  }

  const [tooltipTexId, setTooltipTaxId] = useState(false);
  const iIconTexId = () => {
    return <>
      <img
        id="TooltipTexId"
        src={information}
        style={{
          paddingLeft: "5px",
          position: "relative",
          top: "-1px",
        }}
      />
      <Tooltip
        placement="right"
        isOpen={tooltipTexId}
        target="TooltipTexId"
        toggle={() =>
          setTooltipTaxId(!tooltipTexId)
        }
      >
        {pageLanguageContents?.Arrow2_Account[99]?.Tax_Info}
      </Tooltip>
    </>
  }

  const [tooltipLicense, setTooltipLicense] = useState(false);
  const iIconDrivingLicense = () => {
    return <>
      <img
        id="TooltipLicense"
        src={information}
        style={{
          paddingLeft: "5px",
          position: "relative",
          top: "-1px",
        }}
      />
      <Tooltip
        placement="right"
        isOpen={tooltipLicense}
        target="TooltipLicense"
        toggle={() =>
          setTooltipLicense(!tooltipLicense)
        }
      >
        {pageLanguageContents?.Arrow2_Account[100]?.License_Info}
      </Tooltip>
    </>
  }

  const taxIdType = () => {
    return (
      <>
        <div className="row mx-0 col-12 pl-0">
          <div className="col-6">
            <div className="my-2 label-color">
              <p>
                {pageLanguageContents?.Arrow2_Account[15]?.Tax}
                <span class="star">*</span>
                {iIconTexId()}
              </p>

            </div>
            <div>
              <DecimalNumberInput
                name="taxId"
                maxLength={9}
                decimalSeparator={false}
                placeholder={pageLanguageContents?.Arrow2_Account[16]?.Tax_Placeholder}
              />
            </div>
          </div>
          <div className='col-6 col-xs-12'>
            <div className='my-2  label-color ' >
              <p>{pageLanguageContents?.Arrow2_Account[18]?.DNB}{iIcon()}</p>
            </div>
            <div>
              <NumberInput name='dnbNum' format="##-###-####" placeholder={pageLanguageContents?.Arrow2_Account[19]?.DNB_Placeholder} />
            </div>
          </div>
        </div>
      </>
    );
  }

  const licenseType = () => {
    return (
      <>
        <div className="row mx-0 col-12 pl-0 my-2">
          <div className="col-6">
            <div className="label-color">
              <p>
                {pageLanguageContents?.Arrow2_Account[29]?.DriversLicense}<span class="star">*</span>{iIconDrivingLicense()}
              </p>
            </div>
            <div>
              <TextInput
                name="drivingLicense"
                maxLength={20}
                inputType="textAndNumber"
                placeholder={pageLanguageContents?.Arrow2_Account[29]?.DriversLicense}
              />
            </div>
          </div>
          <div className='col-6'>
            <div className=' label-color ' >
              <p>Drivers License State<span class="star">*</span></p>
            </div>
            <div>
              <Select
                name="drivingLicenseState"
                data={stateArr}
                searchable={true}
                onChangeHandler={() => {
                }}
              />
            </div>
          </div>

        </div>
        <div className="row mx-0 col-12 pl-0">
          <div className='col-6'>
            <div className='label-color'>
              <p>{pageLanguageContents?.Arrow2_Account[32]?.FirstName}<span class="star">*</span></p>
            </div>
            <div>
              <TextInput name='firstName' inputType="text" placeholder={pageLanguageContents?.Arrow2_Account[32]?.FirstName} />
            </div>
          </div>

          <div className='col-6'>
            <div className='label-color'>
              <p>{pageLanguageContents?.Arrow2_Account[33]?.LastName}<span class="star">*</span></p>
            </div>
            <div>
              <TextInput name='lastName' inputType="text" placeholder={pageLanguageContents?.Arrow2_Account[33]?.LastName} />
            </div>
          </div>
        </div>
        <div className="row mx-0 col-12 pl-0">
          <div className="col-6">
            <div className="label-color">
              <p>{pageLanguageContents?.Arrow2_Account[30]?.DOB}<span class="star">*</span></p>
            </div>
            <div className="field date-of-birth">
              <DatePicker name="dob" />
            </div>
          </div>
        </div>
        <div className="row mx-0">
          <div className="col-12 step3">
            <div className=" label-color ">
              <p>{pageLanguageContents?.Arrow2_Account[31]?.UploadDriversLicense}<span class="star">*</span></p>
            </div>
            <div className="stepUpload">
              <UploadSpecification
                name="drivingLicenseDoc"
                acceptFiles={"image/png,image/jpeg"}
                props={props}
                ProfileName=""
                CompanyName=""
                pageType=""
                fileArr={fileArr}
                imageLoadCallBack={(imageArr) => {
                }}
                callBackFun={(imageArr) => {
                  uploadDriverLisence(imageArr)
                }}
              />
            </div>
          </div>
        </div>
      </>
    );
  }

  const onChangeHandlerTaxLicense = (e, propsState) => {
    const { setFieldValue, submitForm, isValid, validateForm, setTouched } = props
    // if (e.target.value === '0') {
    //     taxIdType()
    // } else {
    //     licenseType()
    // }
    validateForm();
    setTouched({});
    setTaxIdState(e.target.value)

    propsState.form.setFieldValue("drivingLicenseDoc", '')
    propsState.form.setFieldValue('taxId', '')

    let date = new Date();
    let plusTwo = date.setFullYear(date.getFullYear() - 18)
    let dateSet = new Date(plusTwo)
    let bidDate = moment(dateSet).format(BIDFORMAT)
    propsState.form.setFieldValue('dob', bidDate)

    setFieldValue("drivingLicenseDoc", '')
    uploadDriverLisence()

    propsState.form.setFieldValue('firstName', '')
    propsState.form.setFieldValue('lastName', '')
    propsState.form.setFieldValue('drivingLicense', '')
    propsState.form.setFieldValue('drivingLicenseState', '')

    propsState.form.setFieldValue('taxidLicense', radioTypes[e.target.value].value)
  };

  return (
    <StepFourContainer>
      <PaymentMethod className="row mx-0">
        <SubHeading>
          <img src={RightArrow} className="right-arrow" alt="right-arrow" />
          {pageLanguageContents?.Arrow2_Account[36]?.Seller_Arrow}<span className="star">*</span>
          {iIconSeller(pageLanguageContents?.Arrow2_Account[103]?.SellerRemittance_Info)}
        </SubHeading>

        <div className='col-12 mb-4'>
          <p style={{ margin: '0px', fontSize: '17px' }}>{`Please populate your payment remittance method. A valid Tax ID ${props?.values?.reseller === "deActive" ? 'or drivers license ' : ''}is required by the payment entity.`}</p>
        </div>

        <div className="col-12">
          <div className={styles.displayFlex}>
            {taxLicenseRadioTypes.map((value, index) => {
              return (
                <div key={index} >
                  <Field
                    component={RadioButton}
                    name="taxidLicense"
                    id={value.value}
                    className="radio-label"
                    defaultValue={radioTypes[0].value}
                    onSelect={(e, propsState) => {
                      onChangeHandlerTaxLicense(e, propsState)
                    }}
                    label={value.label}
                  />
                </div>
              );
            })}
          </div>
        </div>
        {props.values.taxidLicense === "0" && taxIdType()}
        {props.values.taxidLicense === "1" && licenseType()}

        <div className="col-12 mt-3">
          <div className={styles.displayFlex}>
            {radioTypes &&
              radioTypes.map((value, index) => (
                <div key={index}>
                  <Field
                    component={RadioButton}
                    name="accountType"
                    className="radio-label"
                    id={value.value}
                    defaultValue={radioTypes[0].value}
                    disabled={props.values?.sellerPaymentValidated}
                    onSelect={(e) => onChangeHandler(e)}
                    label={value.label}
                  />
                </div>
              ))}
          </div>
        </div>


        <div className="col-12" style={{ overflow: 'hidden' }}>
          {props.values?.sellerPaymentValidated && <div className="freezeDiv"></div>}
          {paymentType === "bankAccount" &&
            <AccountDetail
              props={props}
              setFieldValue={setFieldValue}
              pageLanguageContents={pageLanguageContents}
            />
          }
          {paymentType === "debitCard" &&
            <DebitCard
              cardType="debitCard"
              accountType="debitCard"
              stepSelected="debitCard"
              props={props}
              setFieldValue={setFieldValue}
              id={0}
              pageLanguageContents={pageLanguageContents}
              paymentFor='selling'
            />
          }
        </div>
      </PaymentMethod>
    </StepFourContainer>
  );
};
